import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';

import css from './FeaturedLocalities.module.css';

const FeaturedLocalities = props => {
  const { featured } = props;

  return (
    <div className={css.featuredContent}>
      {featured.slice(0, 3).map(city => {
        return (
          <a href={city.url} className={css.featuredContainer} key={city.url}>
            <div className={css.featuredCard}>
              <div className={css.featuredImage}>
                <AspectRatio ratio={'16:9'} hasImageHover={true}>
                  <img src={city.image} loading="lazy" alt={city.title} />
                </AspectRatio>
              </div>
              <div className={css.featuredDetails}>
                <span className={css.featuredTitle}>{city.title}</span>
                <span>{`${city.listing_count} Listings`}</span>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default FeaturedLocalities;
